import { useEffect, useState } from 'react';

import axios from 'axios';
import { CDNURL } from '../../config';

interface Banner {
  disabled: boolean;
  severity: 'success' | 'info' | 'warn' | 'danger'; // <success (green) | info (blue) | warn (yellow) | danger (red)>
  keyword: string;
  message: string;
}

export function PlatformStatus() {
  const dangerBg = 'bg-red-600';
  const warnBg = 'bg-amber-400';
  const infoBg = 'bg-blue-600';
  const successBg = 'bg-green-600';

  const [banner, setBanner] = useState<Banner[]>([]);

  useEffect(() => {
    if (!CDNURL) {
      console.warn('PlatformStatus: VITE_CDN_URL is not configured');
      return;
    }

    axios
      .get(`${CDNURL}/assets/metadata/banner.json`)
      .then((response) => {
        const nextBanner = Array.isArray(response.data?.banner)
          ? response.data.banner
          : [];

        setBanner(nextBanner);
      })
      .catch((error) => {
        console.error('Error fetching banner', error);
      });
  }, []);

  const getContextualClasses = (severity: string) => {
    switch (severity) {
      case 'success':
        return successBg;
      case 'warn':
        return warnBg;
      case 'danger':
        return dangerBg;
      case 'info':
      default:
        return infoBg;
    }
  };

  return (
    <>
      {banner
        .filter((b) => !b.disabled)
        .map((b, index) => (
          <div
            key={`banner-${index}`}
            className={`py-2 space-x-2 flex flex-col md:flex-row items-center md:justify-center text-lg md:text-lg text-white ${getContextualClasses(b.severity)}`}
          >
            <p className="font-bold text-center md:text-left">{b.keyword}</p>
            <p className="text-center md:text-left">-</p>
            <p className="text-center md:text-left">{b.message}</p>
          </div>
        ))}
    </>
  );
}
